export const services = [
    {
      icon: "/assets/services/code.png",
      title: "JavaScript",
      // description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    },
    {
      icon: "/assets/services/coding.png",
      title: "React",
      // description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    },
    {
      icon: "/assets/services/code.png",
      title: "Node JS",
      // description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    },
    {
      icon: "/assets/services/code.png",
      title: "Python (beginner)",
      // description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    },
    {
      icon: "/assets/services/code.png",
      title: "Rust (beginner)",
      // description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    },
    {
      icon: "/assets/services/website.png",
      title: "Web development",
      // description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    },
  ];